module.exports = __webpack_public_path__ + "img/base_patrimoine_sciences.227de198.svg";